<div class="p-grid searcher-container">
  <form
    [formGroup]="form"
    [spinner]="searchInProgress"
    novalidate
  >
    <label
      [appClickShortcut]="shortcut()"
      class="input-group"
    >
      <span class="input-group-addon">
        <i class="icon-search-icon"></i>
      </span>
      @let placeholder = 'searcher.autocomplete.placeholder' | translate;
      @let shortcutInfo = shortcut() && shortcutLabel() ? ` (${shortcutLabel()})` : '';
      <input
        [placeholder]="placeholder + shortcutInfo"
        (focus)="focused = true"
        data-qa="searcher-input"
        formControlName="query"
        appInput
        type="text"
        class="searcher-input"
      >
    </label>
  </form>
  @if (focused && form.value.query !== '') {
    <div
      #results
      [style.max-width.px]="maxWidth"
      [style.width.px]="resultsWidth"
      [class.empty]="searchResultHidden() && emptyMessageHidden() && enterSearchPhraseHidden()"
      class="results"
    >
      <div
        [hidden]="searchResultHidden()"
        class="fade-in"
      >
        <div
          [hidden]="0 === searchResult.users.length"
          class="group"
        >
          <h3 class="theme-color">
            <i class="icon-users-icon"></i>
            {{ 'searcher.users.header' | translate }}
          </h3>
          <ul>
            @for (user of searchResult.users; track user) {
              <li class="list">
                <app-link [source]="user">
                  <ng-template appTemplate="label">
                    {{ user.fullName }} - {{ user.email }}
                  </ng-template>
                </app-link>
              </li>
            }
          </ul>
        </div>
        <div
          [hidden]="0 === searchResult.groups.length"
          class="group"
        >
          <h3 class="theme-color">
            <i class="icon-groups-icon"></i>
            {{ 'searcher.groups.header' | translate }}
          </h3>
          <ul>
            @for (group of searchResult.groups; track group) {
              <li class="list preserve-white-space">
                <app-link [source]="group"></app-link>
              </li>
            }
          </ul>
        </div>
        <div
          [hidden]="0 === searchResult.policies.length"
          class="group"
        >
          <h3 class="theme-color">
            <i class="icon-policy-icon"></i>
            {{ 'searcher.policies.header' | translate }}
          </h3>
          <ul>
            @for (policy of searchResult.policies; track policy) {
              <li class="list">
                <app-link [source]="policy">
                  <ng-template appTemplate="label">
                    {{ policy.name }} - {{ 'activation_type.' + policy.compatibility | translate }}
                  </ng-template>
                </app-link>
              </li>
            }
          </ul>
        </div>
        <div
          [hidden]="0 === searchResult.profiles.length"
          class="group"
        >
          <h3 class="theme-color">
            <i class="icon-profile-icon"></i>
            {{ 'searcher.profiles.header' | translate }}
          </h3>
          <ul>
            @for (profile of searchResult.profiles; track profile) {
              <li class="list">
                <app-link [source]="profile">
                  <ng-template appTemplate="label">
                    {{ profile.name }} - {{ 'searcher.type.' + PROFILE_TYPE[profile.type] | translate }}
                  </ng-template>
                </app-link>
              </li>
            }
          </ul>
        </div>
        <div
          [hidden]="0 === searchResult.devices.length"
          class="group"
        >
          <h3 class="theme-color">
            <i class="icon-devices-icon"></i>
            {{ 'searcher.devices.header' | translate }}
          </h3>
          <ul>
            @for (device of searchResult.devices; track device) {
              <li class="list">
                <a
                  [routerLink]="device.link"
                  routerLinkActive="active theme-color"
                  class="search-link"
                >
                  {{ device.getDisplayName() }}
                  <span [hidden]="!device.alias">
                    -
                    {{ device.alias }}
                  </span>
                  <span [hidden]="!device.imei">
                      -
                    {{ 'common.imei' | translate }}:
                    {{ device.imei }}
                  </span>
                  <span [hidden]="!device.serialNumber">
                      -
                    {{ 'common.serial_number' | translate }}:
                    {{ device.serialNumber }}
                  </span>
                </a>
              </li>
            }
          </ul>
        </div>
      </div>
      <div
        [hidden]="emptyMessageHidden()"
        class="empty-message fade-in"
      >
        {{ 'searcher.empty_message' | translate }}
      </div>
      <div
        [hidden]="enterSearchPhraseHidden()"
        class="empty-message fade-in"
      >
        {{ 'searcher.enter_search_phrase' | translate }}
      </div>
    </div>
  }
</div>
